module.exports = __webpack_public_path__ + "static/img/cadastro_finalizado.8432809.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cadastro_finalizado.png
// module id = QKsA
// module chunks = 1